import styled from 'styled-components';
import Text from 'styles/typography';

export const Wrapper = styled.div`
  min-width: 100%;
  header {
    width: 100%;
    padding: 13px 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      font-size: 14px;
      font-weight: 500;
      height: 24px;
      color: ${({ theme }) => theme.colors.textLight};
    }
  }
`;

export const GridClaims = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;

  @media (min-width: 1920px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1110px) {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    height: 180px;

    > div {
      min-width: 220px;
    }
  }
`;

export const Title = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const Search = styled.div`
  // height: 48px;
  width: 49%;
  max-width: 280px;

  @media (max-width: 410px) {
    width: auto;
  }
`;
